import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AddressType, useNotificationChannelDappSubscription, useNotificationSubscriptions, useThread, } from '@dialectlabs/react-sdk';
import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import LoadingThread from '../../entities/LoadingThread';
import ConnectionWrapper from '../../entities/wrappers/ConnectionWrapper';
import ThreadEncyprionWrapper from '../../entities/wrappers/ThreadEncryptionWrapper';
import WalletStatesWrapper from '../../entities/wrappers/WalletStatesWrapper';
import GatedWrapper from '../common/GatedWrapper';
import { useTheme } from '../common/providers/DialectThemeProvider';
import { Route, Router, useRoute } from '../common/providers/Router';
import { RouteName } from './constants';
import Header from './Header';
import NotificationsList from './screens/NotificationsList';
import Settings from './screens/Settings';
const ADDRESS_TYPE = AddressType.Wallet;
function InnerNotifications({ dappAddress, onModalClose, onBackClick, channels, notifications, settingsOnly, pollingInterval, }) {
    const { thread, isFetchingThread } = useThread({
        findParams: { otherMembers: [dappAddress] },
    });
    const [isInitialRoutePicked, setInitialRoutePicked] = useState(false);
    const subscription = useNotificationChannelDappSubscription({
        addressType: ADDRESS_TYPE,
        dappAddress,
    });
    const { isFetching: isFetchingNotificationsSubscriptions } = useNotificationSubscriptions({ dappAddress });
    const { scrollbar } = useTheme();
    const { navigate } = useRoute();
    const showThread = useCallback(() => {
        if (!thread) {
            return;
        }
        navigate(RouteName.Thread, {
            params: {
                threadId: thread.id,
            },
        });
    }, [navigate, thread]);
    const showSettings = useCallback(() => {
        navigate(RouteName.Settings);
    }, [navigate]);
    const isLoading = subscription.isFetchingSubscriptions ||
        isFetchingThread ||
        isFetchingNotificationsSubscriptions;
    const isWeb3Enabled = subscription.enabled && Boolean(thread);
    useEffect(function pickInitialRoute() {
        if (isInitialRoutePicked) {
            return;
        }
        if (isLoading) {
            return;
        }
        const shouldShowSettings = settingsOnly || !isWeb3Enabled;
        if (shouldShowSettings) {
            showSettings();
            setInitialRoutePicked(true);
            return;
        }
        showThread();
        setInitialRoutePicked(true);
    }, [
        isInitialRoutePicked,
        isLoading,
        isWeb3Enabled,
        settingsOnly,
        showSettings,
        showThread,
    ]);
    return (_jsxs(React.Fragment, { children: [_jsx(Header, { threadId: thread === null || thread === void 0 ? void 0 : thread.id, isWeb3Enabled: isWeb3Enabled, isReady: !isLoading, onModalClose: onModalClose, onBackClick: onBackClick, settingsOnly: settingsOnly }), _jsx("div", { className: clsx('dt-h-full dt-overflow-y-auto dt-overflow-scroll-contain dt-px-4 dt-pb-[1.5rem]', scrollbar), children: isInitialRoutePicked ? (_jsxs(_Fragment, { children: [_jsx(Route, { name: RouteName.Settings, children: _jsx(Settings, { dappAddress: dappAddress, channels: channels || [], notifications: notifications }) }), _jsx(Route, { name: RouteName.Thread, children: _jsx(NotificationsList, { refreshInterval: pollingInterval }) })] })) : (_jsx(LoadingThread, {})) })] }));
}
export default function Notifications({ gatedView, ...props }) {
    const { dappAddress } = props;
    const { colors, modal } = useTheme();
    const fallbackHeader = (_jsx(Header, { isReady: false, isWeb3Enabled: false, onBackClick: props.onBackClick, onModalClose: props.onModalClose }));
    return (_jsx("div", { className: "dialect dt-h-full", children: _jsx("div", { className: clsx('dt-flex dt-flex-col dt-h-full dt-overflow-hidden', colors.textPrimary, colors.bg, modal), children: _jsx(Router, { children: _jsx(WalletStatesWrapper, { header: fallbackHeader, children: _jsx(ConnectionWrapper, { header: fallbackHeader, pollingInterval: props.pollingInterval, children: _jsx(GatedWrapper, { gatedView: gatedView, children: _jsx(ThreadEncyprionWrapper, { otherMemberAddress: dappAddress, children: _jsx(InnerNotifications, { ...props }) }) }) }) }) }) }) }));
}
//# sourceMappingURL=index.js.map